/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import styles from "./FirstAvailSlot.module.scss";
import clockAfternoon from "images/clockAfternoon.svg";
import { Office } from "types/office";
import dayjs from "dayjs";
import { parseStartTime } from "features/appointmentTime";
import { Button, ButtonRole } from "components/Button";

interface FeatureOfficeProps {
    onSelection: (value: Slot) => void;
    slot: any;
}

export const FirstAvailSlot: React.FC<FeatureOfficeProps> = ({
  onSelection,
  slot
}) => {
  if(!slot || Object.keys(slot).length === 0)
    return false
  const formattedTime = parseStartTime(slot).format("h:mma");
  return (
    <div className={styles.bannerCard}>
        <div className={styles.bannercontianer}>
            <div className={styles.clockDiv}>
                <img
                className={styles.clockIcon}
                src={clockAfternoon}
                alt="clock"
                />
            </div>
            <div className={styles.bannerText}>Next available appointment: <span>{dayjs(slot.date).format("dddd, MMMM D")} at {formattedTime}</span></div>
            <div className={styles.bookTimediv}>
                <Button
                    className={styles.bookTime}
                    text="BOOK THIS TIME"
                    onClick={() => {
                        onSelection(slot);
                        }}
                    role={ButtonRole.Standard}
                />
            </div>
      </div>
    </div>
  );
};
